// Shared password requirements used by Signup, Reset Password, and the
// dashboard's "Change password" section.
//
// "Letter" is implied by needing both upper and lower case. "Symbol" is
// anything non-alphanumeric — covers !?@#$ etc. plus international punctuation.

export const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters',              test: (p) => p.length >= 8 },
  { id: 'upper',  label: 'At least 1 uppercase letter (A-Z)',  test: (p) => /[A-Z]/.test(p) },
  { id: 'lower',  label: 'At least 1 lowercase letter (a-z)',  test: (p) => /[a-z]/.test(p) },
  { id: 'number', label: 'At least 1 number (0-9)',            test: (p) => /[0-9]/.test(p) },
  { id: 'symbol', label: 'At least 1 symbol (e.g. ! ? @ #)',   test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function validatePassword(pw) {
  return PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(pw) }));
}
